var _g, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSdnboxArchived(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 71,
    viewBox: "0 0 61 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_104_5166)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.5,
    cy: 64,
    rx: 8.5,
    ry: 3,
    fill: "black",
    fillOpacity: 0.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_104_5166)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5 4C44.5833 4 56 15.4167 56 29.5C56 40.2983 49.2881 49.5289 39.8087 53.2475L31.9521 63.9865C31.7883 64.2113 31.5709 64.3948 31.3181 64.5215C31.0653 64.6481 30.7846 64.7143 30.4997 64.7143C30.2149 64.7143 29.9342 64.6481 29.6814 64.5215C29.4286 64.3948 29.2111 64.2113 29.0473 63.9865L21.1905 53.2472C11.7115 49.5284 5 40.298 5 29.5C5 15.4167 16.4167 4 30.5 4Z",
    fill: "#D1D1D1"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_104_5166)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_104_5166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0002 35.3709V32.2284L30.6895 25.1641L45.6623 31.101V34.1975L30.145 41.5709L17 35.3707L17.0002 35.3709Z",
    fill: "url(#paint0_radial_104_5166)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.1374 25.5077L31.048 31.6424L44.2172 25.3847L31.3066 19.25L18.1374 25.5077Z",
    fill: "#3253E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.048 31.6425V39.2655L44.2172 33.0077V25.3848L31.048 31.6425Z",
    fill: "#3253E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1374 25.5078L31.048 31.6425V39.2655L18.1374 33.1308V25.5078Z",
    fill: "#002BE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0853 21.6099L31.0226 21.9134L28.9599 22.2169L29.8364 22.5046L27.3431 23.698L28.9776 24.2346L31.471 23.0412L32.3476 23.329L32.7155 22.4691L33.0853 21.6099V21.6099Z",
    fill: "#F2FDFF",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8824 27.3325L25.2503 26.4726L25.6182 25.6127L26.4948 25.9004L28.9881 24.707L30.6227 25.2437L28.1293 26.4371L29.0059 26.7249L26.9432 27.0283L24.8825 27.3325L24.8824 27.3325Z",
    fill: "#F2FDFF",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6152 23.5669L35.5525 23.8704L33.4898 24.1739L34.3663 24.4617L31.873 25.6551L33.5075 26.1917L36.0009 24.9983L36.8775 25.286L37.2454 24.4261L37.6152 23.5669V23.5669Z",
    fill: "#F2FDFF",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4129 29.2891L29.7807 28.4292L30.1486 27.5693L31.0252 27.857L33.5186 26.6636L35.1531 27.2002L32.6598 28.3936L33.5363 28.6814L31.4736 28.9849L29.4129 29.289L29.4129 29.2891Z",
    fill: "#F2FDFF",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_104_5166",
    x: 20,
    y: 59,
    width: 21,
    height: 10,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_104_5166"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_104_5166",
    x: 0,
    y: 0,
    width: 61,
    height: 70.7144,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_104_5166"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_104_5166",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_104_5166",
    x: 11.4093,
    y: 19.5733,
    width: 39.8438,
    height: 27.5882,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.79537,
    result: "effect1_foregroundBlur_104_5166"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_104_5166",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.331 33.3667) scale(14.4146 8.28744)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_104_5166"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 23.25,
    fill: "white",
    transform: "translate(17 19.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdnboxArchived);
export default __webpack_public_path__ + "static/media/sdnbox-archived.d18be6112e90f63bf976210263bf34a8.svg";
export { ForwardRef as ReactComponent };